import React from 'react';
import { Avatar, Tooltip, IconButton, Badge } from '@mui/material';
import { userServerAddress } from '../../common/MetaSetting';

interface UserAvatarProps {
  nickName?: string;
  name?: string;
  username?: string;
  avatarPath?: string;
  onMenuClick?: (event: React.MouseEvent<HTMLElement>) => void;
  tooltip?: string;
  unreadCount?: number;
  variant?: 'circular' | 'rounded' | 'square';
  bgcolor?: string;
  size?: number;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  nickName,
  name,
  username,
  avatarPath,
  onMenuClick,
  tooltip,
  unreadCount = 0,
  variant = 'circular',
  bgcolor,
  size = 32
}) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={onMenuClick} sx={{ p: 0.25 }}>
        <Badge
          badgeContent={unreadCount > 0 ? unreadCount : 0}
          color="primary"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.65rem',
              height: '16px',
              minWidth: '16px'
            }
          }}
        >
          <Avatar
            alt={nickName || name || username || 'User'}
            src={avatarPath ? `${userServerAddress}${avatarPath}` : undefined}
            variant={variant}
            sx={{
              width: size,
              height: size,
              fontSize: `${size * 0.4}px`,
              ...(bgcolor ? { bgcolor } : {})
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).src = '';
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
